import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { InputNumber } from "primereact/inputnumber";
import { useResponsiveDialog } from "../../../../../Context/ResponsiveDialogContext";
import { getValidationRules, isFieldRequired } from "../PreLoan";

export default function StepRent() {
    const { control, formState: { errors } } = useFormContext();
    const { containerWidth } = useResponsiveDialog();

    const isSmall = containerWidth > 0 && containerWidth < 500;
    const stepKey = 'renta'; // Definir el stepKey para este componente
    return (
        <div className="p-fluid">
            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Renta sin IVA {isFieldRequired('renta.sinIva', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="renta.sinIva" rules={getValidationRules('renta.sinIva', stepKey)} control={control} render={({ field }) => (
                        <InputNumber
                            inputId={field.name}
                            name={field.name}
                            value={field.value}
                            onValueChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            mode="currency"
                            currency="MXN"
                            locale="es-MX"
                            className="w-full"
                            minFractionDigits={2}
                            maxFractionDigits={2}
                        />
                    )} />
                    {errors.renta?.sinIva && <small className="p-error">{errors.renta.sinIva.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>IVA</label>
                    <Controller name="renta.iva" rules={getValidationRules('renta.iva', stepKey)} control={control} render={({ field }) => (
                        <InputNumber
                            inputId={field.name}
                            name={field.name}
                            value={field.value}
                            onValueChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            mode="currency"
                            currency="MXN"
                            locale="es-MX"
                            className="w-full"
                            minFractionDigits={2}
                            maxFractionDigits={2}
                        />
                    )} />
                    {errors.renta?.iva && <small className="p-error">{errors.renta.iva.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Total pago mensual c/IVA</label>
                    <Controller name="renta.totalConIva" rules={getValidationRules('renta.totalConIva', stepKey)} control={control} render={({ field }) => (
                        <InputNumber
                            inputId={field.name}
                            name={field.name}
                            value={field.value}
                            onValueChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            mode="currency"
                            currency="MXN"
                            locale="es-MX"
                            className="w-full"
                            minFractionDigits={2}
                            maxFractionDigits={2}
                        />
                    )} />
                    {errors.renta?.totalConIva && <small className="p-error">{errors.renta.totalConIva.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>No. pagos {isFieldRequired('renta.numeroPagos', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="renta.numeroPagos" rules={getValidationRules('renta.numeroPagos', stepKey)} control={control} render={({ field }) => (
                        <InputNumber
                            inputId={field.name}
                            name={field.name}
                            value={field.value}
                            onValueChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            className="w-full"
                            min={1}
                            max={999}
                            useGrouping={false}
                        />
                    )} />
                    {errors.renta?.numeroPagos && <small className="p-error">{errors.renta.numeroPagos.message}</small>}
                </div>
            </div>
        </div>
    );
}


